import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Form, Icon, Table } from 'semantic-ui-react'

class ProductFamilyMemberRow extends React.Component {
  render() {
    const {
      accessory,
      index,
      unlinkFamilyMember,
      preferred,
      handlePreferred,
      dragMarker = {},
    } = this.props //ownProps
    const { isDragging, connectDragSource, connectDropTarget } = this.props //DragSource,DropTarget
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.index === index) {
      dragIndicator = dragMarker.position
    }
    return connectDragSource(
      connectDropTarget(
        <tr className={classNames([rowClass, dragIndicator])}>
          <Table.Cell
            collapsing
            className="draggable"
            content={<Icon {...config.icons.draggable} link />}
          />
          <Table.Cell>
            <strong>{accessory.article_number}</strong>
            <br />
            <span className="german tag">{accessory.title_de}</span>
            <span className="french tag">{accessory.title_fr}</span>
          </Table.Cell>
          <Table.Cell>
            <Form.Checkbox onChange={handlePreferred} checked={preferred} />
          </Table.Cell>
          <Table.Cell textAlign="right">
            <Icon
              link
              {...config.icons.unlink}
              onClick={() => unlinkFamilyMember(index)}
            />
          </Table.Cell>
        </tr>
      )
    )
  }
}

ProductFamilyMemberRow = DropTarget(
  'ProductFamilyMember',
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(ProductFamilyMemberRow)
ProductFamilyMemberRow = DragSource(
  'ProductFamilyMember',
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(ProductFamilyMemberRow)
export default ProductFamilyMemberRow



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductFamilyMemberRow.jsx